import React, {
  useEffect,
  useState
} from 'react';

export interface IData {}

export type IBaseMenuProps = {
  handleClose: () => void;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  open: boolean;
  anchorEl: null | HTMLElement;
  id: string;
};

export function useBaseMenuState() {

  const [
    anchorEl,
    setAnchorEl
  ] = useState<null | HTMLElement>(null);

  let open = Boolean(anchorEl);

  useEffect(() => {
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    open = false;
    setAnchorEl(() => anchorEl);
    () => {};
  }, [anchorEl]);


  return React.useMemo(
    () => {
      const handleClose = () => {
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
        open = false;

        setAnchorEl(() => null);
      };

      const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setAnchorEl(() => e.currentTarget);
      };

      return {
        handleClose,
        handleClick,
        open,
        anchorEl
      };
    },
    [
      anchorEl,
      open
    ]
  );
}


